module.exports = __webpack_public_path__ + "img/font.f8da7419.png";